/**
 * Configuration de l'API Xano
 *
 * Ce fichier gère la configuration des appels API vers Xano.
 * Les URLs des endpoints sont configurées dans le fichier .env
 *
 * @see API_DOCS.md pour la documentation complète des endpoints
 */

// Configuration de base avec valeurs par défaut
const API_BASE_URL = 'https://xpaf-zlrl-h7lr.f2.xano.io';

// Import de la constante TOKEN_KEY
import { TOKEN_KEY } from '../../lib/api/auth';

// Endpoints
export const ENDPOINTS = {
  PORTFOLIO: '/api:99SXOzEt:dev/portfolio_get_one',
  DEAL_FLOW: '/api:99SXOzEt:dev/investment_opportunities',
  FUNDS: '/api:99SXOzEt:dev/get_funds',
  AUTH: {
    LOGIN: '/api:99SXOzEt:dev/auth/login',
    ME: '/api:eUb8OK3m/auth/me',
  },
} as const;

// Vérification de la configuration
if (!API_BASE_URL) {
  // Avertissement désactivé en production
  // console.warn("L'URL de base de l'API Xano n'est pas définie. Vérifiez votre fichier .env");
}

// Types
export type ApiEndpoint = keyof typeof ENDPOINTS;

export const API_CONFIG = {
  /**
   * URL de base de l'API Xano
   */
  BASE_URL: API_BASE_URL,

  /**
   * Endpoints disponibles
   */
  ENDPOINTS: ENDPOINTS,

  /**
   * Fonction utilitaire pour générer dynamiquement les headers d'authentification
   */
  getHeaders() {
    // Utilisation de la constante TOKEN_KEY pour la cohérence
    const authToken = localStorage.getItem(TOKEN_KEY);

    return {
      'Content-Type': 'application/json',
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    };
  },

  /**
   * Récupère l'URL complète d'un endpoint
   * @param endpoint - Nom de l'endpoint
   * @returns URL complète de l'endpoint
   */
  getEndpointUrl(endpoint: ApiEndpoint): string {
    const path = ENDPOINTS[endpoint];
    if (!path) {
      throw new Error(`Endpoint non configuré: ${endpoint}`);
    }
    return `${API_BASE_URL}/${path}`;
  },

  /**
   * Endpoint de refresh token (à adapter selon Xano)
   */
  REFRESH_TOKEN_ENDPOINT: 'api:eUb8OK3m:dev/auth/refresh',
};
